export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const UPDATE_ROLE = 'UPDATE_ROLE';
export const SET_NEW_USER ='SET_NEW_USER';
export const SET_CURRENT_PROMPT ='SET_CURRENT_PROMPT';
export const START_IMPERSONATION = 'START_IMPERSONATION';
export const STOP_IMPERSONATION = 'STOP_IMPERSONATION';
import { IUser } from '@/models/user.model'; // Ensure IUser is imported


export const userLogin = (user: any,token: string,loginMethod: string) => ({
    type: USER_LOGIN,
    payload: {user,token,loginMethod}
});

export const userLogout = () => ({
    type: USER_LOGOUT,
});

export const setNewUser = (status: boolean) => ({
    type: SET_NEW_USER,
    payload: status
})


export const roleUpdate = (role:string) => ({
    type: UPDATE_ROLE,
    payload: {role}
})

export const setCurrentPrompt = (prompt:string) => ({
    type: SET_CURRENT_PROMPT,
    payload: prompt
})


export const startImpersonation = (user: IUser, token: string) => ({
    type: START_IMPERSONATION,
    payload: { user, token }
});

export const stopImpersonation = () => ({
    type: STOP_IMPERSONATION,
});
